import { Dispatch } from '@reduxjs/toolkit';
import complianceEstSlice from './complianceEstSlice';
import { CommentItem } from './types';
import ApiService from 'utils/ApiCalls';
import Helpers from 'utils/Helpers';
import { IFilters, LanguageList } from '../globalTypes';

const {
  set_filters_data,
  set_draw_table,
  set_loading,
  set_save_disabled,
  set_comments_data,
  set_save_clicked,
  set_data_edited,
  set_tasks_updated
} = complianceEstSlice.actions;

const setFilters = (lang: LanguageList) => async (dispatch: Dispatch) => {
  try {
    dispatch(set_loading());
    const response = await ApiService.getFilters(lang);
    let fetchedFilters: IFilters[] = [];

    if (response?.data && !Helpers.isObjEmpty(response.data)) {
      fetchedFilters = Object.keys(response.data)
        .filter((key) => {
          const filterOptions = response.data[key];
          return Array.isArray(filterOptions) && filterOptions.length > 0;
        })
        .map((key) => {
          const filterName = key.charAt(0).toUpperCase() + key.slice(1);
          const filterOptions = response.data[key];
          const options = filterOptions
            .map((option: any) => {
              if (typeof option === 'string') {
                return {
                  value: option,
                  label: option
                };
              }

              if (option && typeof option === 'object') {
                return {
                  value: option.id ?? option.value ?? option.name,
                  label: option.name ?? option.label ?? option.value
                };
              }

              return null;
            })
            .filter(Boolean);
          return {
            filter: filterName,
            options,
            value: []
          };
        })
        .filter((filter) => filter.options.length > 0);
    }
    dispatch(set_filters_data(fetchedFilters));
  } catch (error) {
    console.error('setFilters error:', error);
    dispatch(set_filters_data([]));
  }
};

const applyFiltersApi = async (
  lang: LanguageList,
  filters: Record<string, string[]>
) => {
  try {
    const response = await ApiService.applyFilters(lang, filters);
    return response.data || [];
  } catch (error) {
    return [];
  }
};

// const fetchComments = async (table: CommentTable) => {
//   try {
//     const response = await ApiService.getComments(table);

//     return response.data;
//   } catch (error) {
//     console.error(error);
//   }
// };

// const saveComment = async (data: CommentItem[]) => {
//   try {
//     const response = await ApiService.addComment(data);

//     notification.success({
//       message: response.status,
//       description: response.data.message
//     });
//   } catch (error) {
//     console.error(error);
//   }
// };

// const deleteComment = async (comment_id: number) => {
//   try {
//     const response = await ApiService.removeComment(comment_id);

//     notification.success({
//       message: response.status,
//       description: response.data.message
//     });
//   } catch (error) {
//     console.error(error);
//   }
// };

const setDrawTable = (draw: boolean) => (dispatch: Dispatch) => {
  try {
    dispatch(set_loading());
    dispatch(set_draw_table(draw));
  } catch (error) {
    console.error(error);
  }
};

export const setSaveDisabled = (disabled: boolean) => (dispatch: Dispatch) => {
  try {
    dispatch(set_save_disabled(disabled));
  } catch (error) {
    console.error(error);
  }
};

const setCommentsData =
  (commentsData: CommentItem[]) => (dispatch: Dispatch) => {
    try {
      dispatch(set_loading());
      dispatch(set_comments_data(commentsData));
    } catch (error) {
      console.error(error);
    }
  };

const setSaveClicked = (saveClicked: boolean) => (dispatch: Dispatch) => {
  try {
    dispatch(set_loading());
    dispatch(set_save_clicked(saveClicked));
  } catch (error) {
    console.error(error);
  }
};

const setDataEdited = (edited: boolean) => (dispatch: Dispatch) => {
  dispatch(set_data_edited(edited));
};

const setTasksUpdated = (value: boolean) => (dispatch: Dispatch) => {
  dispatch(set_tasks_updated(value));
};

export default {
  setFilters,
  applyFiltersApi,
  // fetchComments,
  // saveComment,
  // deleteComment,
  setDrawTable,
  setSaveDisabled,
  setCommentsData,
  setSaveClicked,
  setDataEdited,
  setTasksUpdated
};
